import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { getNewFileFormGroup } from '@app/helpers/form.helper';
import { FileUploadControl } from '@app/models/form.models';
import { FileType } from '@app/models/shared.enums';

export interface SectionJFormGroup {
  companyExtracts: FormArray<FormGroup<FileUploadControl>>;
  technicalUpload: FormArray<FormGroup<FileUploadControl>>;
  valuation: FormArray<FormGroup<FileUploadControl>>;
  mainImage: FormArray<FormGroup<FileUploadControl>>;
  otherDocs: FormArray<FormGroup<FileUploadControl>>;
  images: FormArray<FormGroup<FileUploadControl>>;
  videos: FormArray<FormGroup<FileUploadControl>>;
}

const requiredUploadValidator: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  const fileArray = control as FormArray<FormGroup<FileUploadControl>>;
  const hasUploadedFile = fileArray.controls.some((group) => {
    const hasSelectedFile = group.controls.file.value !== null;
    const hasExistingTitle = (group.controls.title.value?.trim() ?? '') !== '';
    return hasSelectedFile || hasExistingTitle;
  });
  return hasUploadedFile ? null : { requiredUpload: true };
};

export function getSectionJFormGroup(
  fb: FormBuilder
): FormGroup<SectionJFormGroup> {
  return fb.nonNullable.group({
    companyExtracts: fb.nonNullable.array<FormGroup<FileUploadControl>>([
      getNewFileFormGroup(fb, FileType.documentCompanyRegistration, false, true),
    ]),
    technicalUpload: fb.nonNullable.array<FormGroup<FileUploadControl>>([
      getNewFileFormGroup(fb, FileType.documentTechnicalDescription, false, true),
    ]),
    valuation: fb.nonNullable.array<FormGroup<FileUploadControl>>([
      getNewFileFormGroup(fb, FileType.documentValuation, false, true),
    ]),
    mainImage: fb.nonNullable.array<FormGroup<FileUploadControl>>(
      [getNewFileFormGroup(fb, FileType.mainImage, false, true)],
      [requiredUploadValidator],
    ),
    otherDocs: fb.nonNullable.array<FormGroup<FileUploadControl>>([
      getNewFileFormGroup(fb, FileType.document, false, true),
    ]),
    images: fb.nonNullable.array<FormGroup<FileUploadControl>>([
      getNewFileFormGroup(fb, FileType.image, false, true),
    ]),
    videos: fb.nonNullable.array<FormGroup<FileUploadControl>>([
      getNewFileFormGroup(fb, FileType.video, false, true),
    ]),
  });
}
